import { theme } from 'lib/utils/style/theme';
import React from 'react';

interface OwnProps {
  color?: string;
}

const Logo = ({ color = theme.primary[6] }: OwnProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <mask
        id="mask0_144_2125"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <path d="M0 0H48V48H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_144_2125)">
        <path
          d="M30.8733 47.9999C34.061 47.9999 38.3861 47.1932 42.8589 43.9401C44.0498 43.074 44.1309 41.3724 43.1458 40.2775L42.6434 39.7188C41.6581 38.6239 39.9829 38.5585 38.7591 39.3785C32.1791 43.7884 25.7845 41.486 23.6693 39.5119C23.4862 39.3265 23.5953 39.0111 23.8535 38.9767C31.1773 37.9996 36.4703 32.8689 36.8453 32.498C42.7114 26.7199 44.0453 18.8819 39.8693 14.6379C35.6933 10.3939 27.8394 11.5939 21.9693 17.3519C21.563 17.7408 17.9037 21.3303 15.8346 26.328C15.0673 28.1817 12.7041 29.0484 11.5639 27.3977C11.2083 26.8828 10.8879 26.3428 10.6054 25.7807C9.65867 23.8968 9.16422 21.8183 9.16134 19.7099C9.1467 17.9263 9.49256 16.1581 10.1782 14.5116C10.8638 12.8649 11.8751 11.3739 13.1513 10.1279C15.239 8.08867 18.0053 6.76707 21.1067 6.28867C22.5623 6.06413 23.7633 4.894 23.7633 3.4212V2.66653C23.7633 1.19377 22.5657 -0.0168267 21.1022 0.14844C16.3894 0.68064 12.1281 2.62853 8.90334 5.76387C5.14134 9.42387 3.06934 14.3719 3.06934 19.7099C3.07544 23.6107 4.24179 27.4215 6.41998 30.6572C8.38144 33.5713 11.0835 35.9004 14.2391 37.4113C14.9074 37.7313 15.4386 38.2812 15.7569 38.9503C16.6101 40.7436 17.8646 42.4185 19.5133 43.962C21.4533 45.7719 25.2433 47.7777 30.0733 47.9817C30.3319 47.9951 30.5986 48.0012 30.8733 47.9999ZM33.4333 18.1539C34.2834 18.1539 35.0133 18.3839 35.5253 18.9039C37.0234 20.4279 36.0754 24.7119 32.5653 28.17L32.5493 28.1879C32.4994 28.2359 27.013 33.5564 20.5094 33.0167C20.5037 33.0161 20.4993 33.0116 20.4993 33.006C20.4693 27.2599 26.1153 21.8119 26.1733 21.7559L26.2133 21.7179C28.2994 19.6639 31.2594 18.1539 33.4333 18.1539Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Logo;
